import { action, extendObservable } from "mobx";
import _ from "lodash";
import { AlertConstants } from "../constants/AlertConstants";

class AlertStore {
  constructor() {
    this.defaults = {
      alerts: [],
      errorResponse: [],
      showOverrideModal: false
    };

    extendObservable(this, {
      alerts: this.defaults["alerts"],
      errorResponse: this.defaults["errorResponse"],
      showOverrideModal: this.defaults["showOverrideModal"],
      addAlert: action(alert => {
        alert.id = this.getAlertId();
        this.alerts.push(alert);
        this.alerts = _.uniqBy(this.alerts, alert => {
          return alert.type + alert.text;
        });
      }),
      removeAlert: action(id => {
        if (id) {
          this.alerts = _.reject(this.alerts, function(a) {
            return a.id === id;
          });
        }
      }),
      resetStore: action(() => {
        this.alerts = this.defaults["alerts"];
        this.errorResponse = this.defaults["errorResponse"];
        this.showOverrideModal = this.defaults["showOverrideModal"];
      })
    });
  }

  getAlertId() {
    return (
      "_" +
      Math.random()
        .toString(36)
        .substr(2, 9)
    );
  }

  createResponseAlerts(alerts) {
    alerts.forEach(alert => {
      let type;
      switch (alert.severity) {
        case "SUCCESS":
          type = AlertConstants.TYPES.SUCCESS;
          break;
        case "INFO":
          type = AlertConstants.TYPES.INFO;
          break;
        case "ERROR":
          type = AlertConstants.TYPES.DANGER;
          break;
        case "WARNING":
        default:
          type = AlertConstants.TYPES.WARNING;
          break;
      }
      this.addAlert({
        type: type,
        text: alert.message
      });
    });
  }
}

export default AlertStore;
